module.exports = __webpack_public_path__ + "img/LF008-05.db4fd0f7.jpg";